var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_289_6148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98892 3.99414H4.99446C4.44279 3.99414 3.99557 4.44136 3.99557 4.99303V9.98749C3.99557 10.5392 4.44279 10.9864 4.99446 10.9864H9.98892C10.5406 10.9864 10.9878 10.5392 10.9878 9.98749V4.99303C10.9878 4.44136 10.5406 3.99414 9.98892 3.99414Z",
    stroke: "white",
    strokeWidth: 0.998892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99778 7.99029C1.44839 7.99029 0.99889 7.54079 0.99889 6.9914V1.99694C0.99889 1.44755 1.44839 0.998047 1.99778 0.998047H6.99224C7.54163 0.998047 7.99113 1.44755 7.99113 1.99694",
    stroke: "white",
    strokeWidth: 0.998892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_6148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9867,
    height: 11.9867,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d0d54474dad661bf9b1898cd8f66fde8.svg";
export { ForwardRef as ReactComponent };